// IMG FALLBACK - битая картинка -> заглушка вместо пустого квадрата.
// Один capture-слушатель на документ ловит error любой картинки на любой
// странице (lazy тоже): локальные uploads до переезда на CDN, мёртвые
// остатки CDN - всё едет заглушкой, вёрстка не разваливается.
( () => {

    // нейтральная заглушка data-URI - без лишнего запроса, живёт без CDN
    const PLACEHOLDER = 'data:image/svg+xml;charset=utf-8,'
        + encodeURIComponent(
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 350">'
            + '<rect width="350" height="350" fill="#eef1f4"/>'
            + '<g fill="none" stroke="#c4ccd4" stroke-width="10" stroke-linecap="round" stroke-linejoin="round">'
            + '<rect x="95" y="105" width="160" height="140" rx="14"/>'
            + '<circle cx="140" cy="150" r="14"/>'
            + '<path d="M110 225l45-45 30 30 25-25 40 40"/>'
            + '</g>'
            + '</svg>'
        );

    const swap = ( img ) => {

        // не зацикливаемся, если вдруг сломается сама заглушка
        if( img.dataset.fallback )
            return;

        img.dataset.fallback = '1';
        img.src              = PLACEHOLDER;

        // srcset/размеры от битого источника больше не мешают
        img.removeAttribute('srcset');
        img.classList.add('img-fallback');
    };

    // будущие ошибки (lazy, доклейка Load More, слайдеры)
    document.addEventListener( 'error', ( e ) => {

        if( e.target instanceof HTMLImageElement )
            swap( e.target );
    }, true );

    // уже сломавшиеся до запуска скрипта - error у них не повторится
    document.addEventListener( 'DOMContentLoaded', () => {

        document.querySelectorAll('img').forEach( ( img ) => {

            if( img.complete && ! img.naturalWidth && img.src )
                swap( img );
        } );
    } );
} )();